import { connect } from "react-redux"

import { autocompleteTopicsRequest } from "../../../../actions/autocomplete-actions"

import KeyIssueEditRelatedInsightAreas from "./KeyIssueEditRelatedInsightAreas"

const mapDispatchToProps = (dispatch, props) => ({
    onTopicsSearch: (searchTerm, callback) => {
        dispatch(autocompleteTopicsRequest(searchTerm, callback))
    },
    ...props
})

export default connect(null, mapDispatchToProps)(
    KeyIssueEditRelatedInsightAreas
)
